module.exports = __webpack_public_path__ + "img/200105.5c61ae07.png";